module.exports = __webpack_public_path__ + "static/media/tabela.2b4b58e6.png";